module.exports = __webpack_public_path__ + "static/img/score-mobile-4.46249820.png";